import { GlobalStyles, JasmineThemeProvider, theme as themes } from '@Thread-Magic/jasmine';
import { ConfigProvider } from 'antd';
import PropTypes from 'prop-types';
import { ThemeProvider, createGlobalStyle } from 'styled-components';
import { darken } from 'polished';
import useThemeMode from '../hooks/useThemeMode';
import customTheme from '../styles/AntDTheme';

const GlobalScrollbarStyles = createGlobalStyle`
:root {
  --scrollbar-width: 12px;
  --scrollbar-min-size: 32px;
  --scrollbar-color:  ${({ theme }) => (theme.isDark ? theme.colors.gray6 : theme.colors.gray4)};
}
*::-webkit-scrollbar {
  width: var(--scrollbar-width);
  height: var(--scrollbar-width);
}
* {
  -ms-overflow-style: -ms-autohiding-scrollbar;
  scrollbar-width: thin;
  scrollbar-color: var(--scrollbar-color) transparent;
}


*::-webkit-scrollbar-track {
  background: transparent;
}

*::-webkit-scrollbar-thumb {
  background-color: var(--scrollbar-color);
  opacity: 0.2;
  border-radius: var(--scrollbar-width);
  border: 3px solid transparent;
  background-clip: content-box;
}

*::-webkit-scrollbar-thumb:vertical {
  min-height: var(--scrollbar-min-size);
}

*::-webkit-scrollbar-thumb:horizontal {
  min-width: var(--scrollbar-min-size);
}

*::-webkit-scrollbar-thumb:hover {
  --scrollbar-color: ${({ theme }) =>
    theme.isDark ? darken(0.1, theme.colors.gray6) : theme.colors.gray5};
}

*::-webkit-scrollbar-thumb:active {
  --scrollbar-color: ${({ theme }) =>
    theme.isDark ? darken(0.1, theme.colors.gray6) : theme.colors.gray5};
}
`;

export default function ThemeProviders({ children }) {
  const [themeMode, toggleThemeMode] = useThemeMode();

  return (
    <JasmineThemeProvider themeMode={themeMode}>
      <ThemeProvider theme={{ ...themes[themeMode], toggleThemeMode }}>
        <ConfigProvider theme={customTheme(themeMode)}>
          <GlobalStyles />
          <GlobalScrollbarStyles />
          {children}
        </ConfigProvider>
      </ThemeProvider>
    </JasmineThemeProvider>
  );
}
ThemeProviders.propTypes = {
  children: PropTypes.node.isRequired
};
